import { DEBIT_NOTE_BILL_BASE_REQUEST, CREATE_DEBIT_NOTE_BILL_BASE, GET_DEBIT_NOTE_BILL_BASES, UPDATE_DEBIT_NOTE_BILL_BASE,
  DELETE_DEBIT_NOTE_BILL_BASE, DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, DEBIT_NOTE_BILL_BASE_REQUEST_SUCCESS, GET_DEBIT_NOTES_BILL_BASES_PAGE } from '../types';

const initialState = {
  debitNoteBillBases: [],
  debitNoteBillBasesPage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const debitNoteBillBaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case DEBIT_NOTE_BILL_BASE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_DEBIT_NOTE_BILL_BASES: {
      return {
        ...state,
        debitNoteBillBases: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_DEBIT_NOTES_BILL_BASES_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        debitNoteBillBasesPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_DEBIT_NOTE_BILL_BASE: {
      return {
        ...state,
        debitNoteBillBases: [action.payload, ...state.debitNoteBillBases],
        loading: false,
        error: null
      };
    }
    case UPDATE_DEBIT_NOTE_BILL_BASE: {
      const debitNoteBillBasesData = state.debitNoteBillBases.slice(0);
      const uIndex = debitNoteBillBasesData.findIndex((data) => data.id === action.payload.id);
      debitNoteBillBasesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        debitNoteBillBases: [ ...debitNoteBillBasesData ],
        loading: false,
        error: null
      };
    }
    case DELETE_DEBIT_NOTE_BILL_BASE: {
      const debitNoteBillBases = state.debitNoteBillBases?.slice(0);
      const index = debitNoteBillBases.findIndex((data) => data.id === action.id);
      if (index > -1) {
        debitNoteBillBases.splice(index, 1);
      }
      return {
        ...state,
        debitNoteBillBases: [...debitNoteBillBases],
        loading: false,
        error: null
      }
    }
    case DEBIT_NOTE_BILL_BASE_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default debitNoteBillBaseReducer;